"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const CloseButton = props => {
    const { onClickHandle } = props;
    return (react_1.default.createElement(styled_1.StyledCloseButton, { onClick: onClickHandle, className: "modal-button-container" },
        react_1.default.createElement("button", { className: "display-modal-close-button" },
            react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "white", role: "img" },
                react_1.default.createElement("path", { d: "M21.474 3.467l-.942-.941L12 11.059 3.466 2.526l-.94.941L11.059 12l-8.533 8.532.94.942L12 12.941l8.532 8.533.942-.942L12.941 12z" })))));
};
exports.CloseButton = CloseButton;
